import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';

const getPaymentSummary = async (tab, page = 0, page_size = 15, from_date, till_date) => {
    const storageAvailable = localStorageAvailable();
    const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';
    const mode = localStorage.getItem('mode')
    const config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: '/service/accounts_service/v1/info/online_payments',
        headers: {
            authorization: `Bearer ${accessToken}`,
        },
        params: {
            page_size,
            page,
            tab,
            from_date,
            till_date,
            mode
        },
    };

    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error('Error fetching event data:', error);
        throw error;
    }
};

export default getPaymentSummary;
